import { Controller } from "@hotwired/stimulus"

// This controller is used perform an email verification inside a turbo frame.
export default class extends Controller {
  static get targets() {
    return ["button", "tag", "frame"]
  }

  static get values() {
    return { email: String, variant: String }
  }

  // This action submits an email verification.
  verifyEmail(event) {
    event.preventDefault()

    if (! this.hasEmailValue) {
      return
    }

    this.frameTarget.src = App.api.verifyEmail(this.emailValue, "html", this.variantValue)
    this.frameTarget.reload()
    this.frameTarget.loaded.then(() => {
      this.dispatch("loaded")
    })
  }

  // This action render the result of an email verification. We are triggering this from using the
  // verify-email-result controller.
  renderResult({ detail: { element } }) {
    this.tagTarget.innerHTML = element.innerHTML
    this.buttonTarget.classList.add("d-none")
    element.remove()
  }

  // This action hides the verify button.
  hideButton() {
    this.buttonTarget.classList.add("d-none")
  }
}
